import { trackNewsletterJourneyEvent } from "../data/consultations";

const STORAGE_KEY = "newsletterJourneySession";

function createSessionId() {
  return `nls-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function sanitizeNewsletterJourneyPath(rawPath) {
  if (!rawPath) {
    return "/";
  }

  try {
    const url = new URL(rawPath, window.location.origin);
    if (url.searchParams.has("token")) {
      url.searchParams.set("token", "[secure]");
    }
    const query = url.searchParams.toString();
    return `${url.pathname}${query ? `?${query}` : ""}${url.hash || ""}`;
  } catch {
    return rawPath.replace(/token=([^&]+)/, "token=[secure]");
  }
}

export function getStoredNewsletterJourneySession() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.token || !parsed?.sessionId) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearStoredNewsletterJourneySession() {
  if (typeof window === "undefined") {
    return;
  }
  window.sessionStorage.removeItem(STORAGE_KEY);
}

export function storeNewsletterJourneySession(token, consultation = {}) {
  if (typeof window === "undefined" || !token) {
    return null;
  }

  const existing = getStoredNewsletterJourneySession();
  const nextSession =
    existing && existing.token === token
      ? {
          ...existing,
          consultationId: consultation.id || existing.consultationId || "",
          companyName: consultation.companyName || existing.companyName || "",
          contactName: consultation.contactName || existing.contactName || "",
        }
      : {
          token,
          sessionId: createSessionId(),
          consultationId: consultation.id || "",
          companyName: consultation.companyName || "",
          contactName: consultation.contactName || "",
          createdAt: new Date().toISOString(),
          sessionStartedTracked: false,
        };

  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(nextSession));
  return nextSession;
}

export function markNewsletterJourneySessionStarted() {
  const session = getStoredNewsletterJourneySession();
  if (!session) return;
  window.sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      ...session,
      sessionStartedTracked: true,
    })
  );
}

export async function sendNewsletterJourneyEvent(eventType, options = {}) {
  const session = getStoredNewsletterJourneySession();
  if (!session?.token || !session?.sessionId) {
    return;
  }

  try {
    await trackNewsletterJourneyEvent({
      token: session.token,
      sessionId: session.sessionId,
      eventType,
      pagePath: sanitizeNewsletterJourneyPath(options.pagePath || ""),
      metadata: options.metadata || null,
    });
  } catch (error) {
    const message = String(error?.message || "").toLowerCase();
    if (message.includes("expired") || message.includes("invalid")) {
      clearStoredNewsletterJourneySession();
    }
  }
}
